import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'startsWith'
})
export class StartsWithPipe implements PipeTransform {
    /**
     * Return a list of filtered values based on a query match per field per value
     * @param values: Passed in by Angular, these will be the repeater values
     * @param query: The search string to use to match against the values
     * @param field: The field to search within each value
     */
    transform(values: Array<any>, query: string, field: string): any {
        return values.filter((value) => value[field].toLowerCase().includes(query ? query.toLowerCase() : ''));
    }
}
